module.exports = require("@pb/kit-component-portal");